import React from "react";

const Terrain = ({ points }) => {
  // Draws the stock price line as terrain
  const pathData = points
    .map((p, i) => (i === 0 ? `M${p.x},${p.y}` : `L${p.x},${p.y}`))
    .join(" ");
  return (
    <path d={pathData} stroke="#222" strokeWidth={4} fill="none" />
  );
};

export default Terrain;